<template>
  <div :style="{ height: toggle ? '350px' : '550px' }" class="main-container">
    <div
      :style="{
        'overflow-y': toggle ? 'hidden' : 'scroll',
        height: toggle ? '250px' : '450px',
      }"
      class="main-div"
    >
      <div class="heading-name">
        <img
          v-if="type == 'crops'"
          height="20"
          width="20"
          src="../../../../assets/userDetails/crop.svg"
        />
        <img
          v-else
          height="20"
          width="20"
          src="../../../../assets/userDetails/brandsIcon.svg"
        />
        <p class="heading-text">{{ heading }}</p>
        <!-- <p class="crops-text">10 {{ type }}</p> -->
      </div>
      <v-divider />

      <div class="details">
        <div class="options">
          <p  v-if="type == 'crops' ">Crop Image</p>
          <p style="width:25%">Crop Name</p>
          <p style="width:25%">Season</p>
          <p style="width:25%">Diseases</p>
          <p style="width:25%">Variety</p>
          <p v-if="type == 'items'"></p>
        </div>

        <v-divider />
        <div class="answer-div" v-for="item in data" :key="item.crop_name">
          <div class="option-answer">
            <div  v-if="type == 'crops' "><img :src="item.image?item.image.original:'../../../../assets/userDetails/dummycrop.svg'"  style="height: 60px; width: 60px; border-radius: 50%"/></div>
            <p style="width:25%">{{ item.crop_name }}</p>
           <p style="width:25%">{{item.season}}</p>
             <p style="width:25%">{{item.disease_name}}</p>
            <p style="width:25%">{{item.variety}}</p>
         
           
            <div v-if="type == 'items'"></div>
          </div>
          <v-divider />
        </div>
      </div>
    </div>
    <div class="bottom-div">
      <button v-if="toggle" @click="handleToggle" class="bottom-button">
        See All Crops
      </button>
      <button v-else @click="handleToggle" class="bottom-button">
        See Less Crops
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "listingCard",
  data() {
    return {
     // data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      toggle: true,
    };
  },
  props: {
    heading: String,
    type: String,
    data: Array,
  },
  methods: {
    handleToggle() {
      this.toggle = !this.toggle;
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  height: 650px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
}
.main-div {
  height: 550px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: #fff;
  p {
    margin-bottom: 0px;
  }
}
.heading-name {
  height: 52px;
  min-height: 52px;
  margin-left: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.heading-text {
  color: #3a3f3a;
  font-size: 16px;
  font-weight: 500;
}
.crops-text {
  color: #189d3b;
  font-size: 14px;
  font-weight: 500;
}
.details {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.answer-div {
}
.options {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-direction: row;
  height: 56px;
  text-align: left;
  margin-left: 64px;
  p {
    font-size: 14px;
    color: #777777;
    width: 20%;
  }
}
.option-answer {
  display: flex;
  margin-left: 64px;
  align-items: center;
  text-align: left;
    gap: 20px;
  height: 72px;
  p {
    width: 25%;
  }
  div {
    width: 20%;
  }
}
.bottom-div {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom-button {
  height: 40px;
  width: 166px;
  background: #f3faf5;
  color: #189d3b;
  font-weight: 500;
  border-radius: 5px;
}
</style>
